var map = {
	"./BTE/ar.json": 2967,
	"./BTE/en.json": 4756,
	"./BTE/fr.json": 6414,
	"./FERCHIOU/ar.json": 8252,
	"./FERCHIOU/en.json": 1361,
	"./FERCHIOU/fr.json": 3032,
	"./default/ar.json": 8648,
	"./default/en.json": 7731,
	"./default/fr.json": 6056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2444;